<template>
    <div class="TTL-radio">
    <el-radio-group v-model="inputvalue" class="ml-4" @change="ChangeData">
    <el-radio v-for="(item,index) in list" :key="index"  :label="item.id">{{item.name}}</el-radio>
    </el-radio-group>
    </div>
</template>

<script>
export default {
  props: ['value','list'],
  data() {
      return {
          inputvalue:this.value,
          list:this.list && this.list.length > 0 ? this.list : [],
      }
  },

  watch: {
      value(val) {
          this.inputvalue=val;
      },
      list(val) {
          this.list=val;
      },
  },

  mounted() {
      
  },

  methods: {


      /** 修改数据，变更 **/
      ChangeData() {
          this.$emit('finish',{type:'change',value:this.inputvalue});
      },

  }

}
</script>

<style scoped>
::v-deep(.el-radio__input.is-checked + .el-radio__label) {color:#666666;}
::v-deep(.el-radio__inner::after) {background-color:#666eeb;}
</style>